module.exports = __webpack_public_path__ + "static/img/pingTaiBox1.f8ea80e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pingTaiBox1.png
// module id = Pp3j
// module chunks = 2